import { toString } from "lodash";
import { paginationDefaults } from "../../utils/properties";

const SET_FILTERS = "SET_FILTERS";
const SET_FILTERS_LIST = "SET_FILTERS_LIST";
const INIT_FILTERS = "INIT_FILTERS";

export function setFiltersList(payload) {
  return {
    type: SET_FILTERS_LIST,
    payload,
  };
}

export function setFilters(payload) {
  return {
    type: SET_FILTERS,
    payload,
  };
}

export function initFilters() {
  return {
    type: INIT_FILTERS,
    payload: {},
  };
}

const INIT_STATE = {
  filtersList: {
    // Necessary for projects management and project estimate becouse I have to mantain filters in list and in details
    string: `page=${paginationDefaults.page - 1}&size=${paginationDefaults.size}`,
    obj: {
      page: toString(paginationDefaults.page - 1),
      size: toString(paginationDefaults.size),
    },
  },
  filters: {
    string: `page=${paginationDefaults.page - 1}&size=${paginationDefaults.size}`,
    obj: {
      page: toString(paginationDefaults.page - 1),
      size: toString(paginationDefaults.size),
    },
  },
};

export default function FiltersDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case SET_FILTERS_LIST:
      newState.filtersList = action.payload;
      break;
    case SET_FILTERS:
      newState.filters = action.payload;
      break;
    case INIT_FILTERS: // If I set INIT_STATE not work correctly so I must to rewrite all.
      newState = {
        filtersList: {
          // Necessary for projects management and project estimate becouse I have to mantain filters in list and in details
          string: `page=${paginationDefaults.page - 1}&size=${paginationDefaults.size}`,
          obj: {
            page: toString(paginationDefaults.page - 1),
            size: toString(paginationDefaults.size),
          },
        },
        filters: {
          string: `page=${paginationDefaults.page - 1}&size=${paginationDefaults.size}`,
          obj: {
            page: toString(paginationDefaults.page - 1),
            size: toString(paginationDefaults.size),
          },
        },
      };
      break;
    default:
      break;
  }
  return newState;
}
